import { render } from "./MobileProductsPage.vue?vue&type=template&id=7fbf6eb4"
import script from "./MobileProductsPage.vue?vue&type=script&lang=js"
export * from "./MobileProductsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__